
  const jobPosition = document.querySelector('[data-forms-id="forms-root-678695"]');

  if (jobPosition) {
    const dataPositionFormEl = document.querySelector('[data-position_form]');
    let dataPositionForm = '';

    if (dataPositionFormEl) {
      try {
        dataPositionForm = JSON.parse(dataPositionFormEl.textContent);
      } catch (e) {
        console.error('JSON parse error:', e);
      }
    }
      
    function waitForElement(selector, root = document) {
      return new Promise(resolve => {
        const el = root.querySelector(selector);
        if (el) return resolve(el);

        const observer = new MutationObserver(() => {
          const el = root.querySelector(selector);
          if (el) {
            resolve(el);
            observer.disconnect();
          }
        });

        observer.observe(root, { childList: true, subtree: true });
      });
    }

    waitForElement('shopify-forms-embed#app-embed').then(formEmbed => {
      const shadow = formEmbed.shadowRoot;

      if (shadow) {
        const style = document.createElement('style');
        style.textContent = `
          :host {
            --input-label-transform: translateY(var(--input-label-Y-transform)) scale(0.65) !important;
          }
            
           h2 {
            font: normal 700 32px var(--LAGUNA-FONT) !important; 
            text-align: center !important;
          }

          label, input, select, textarea, legend, button, span {
              font: normal 400 14px var(--GOTHAM-FONT) !important; 
          }

          div#form-container-ref p {
            font-family: var(--GOTHAM-FONT) !important;
            font-size: 16px !important;
            line-height: 1.4 !important;
            font-weight: var(--FONT-WEIGHT-REGULAR) !important;
            color: #7a7a7a !important;
          }

          div._selectContainer_12thd_6 p {
            padding: 0 !important;
            position: absolute !important;
            bottom: 12px !important;
            left: 0 !important;
          }

          div#form-container-ref div._textBody_2aowh_10 p {
            color: #000000 !important;
          }

          div#form-container-ref input,
          button[aria-controls="country-selector-dropdown"],
          div#form-container-ref textarea,
          div._selectContainer_12thd_6 button {
            border-radius: 0 !important;
            border-bottom: 1px solid rgba(0, 0, 0, 0.35) !important;
            box-shadow: none !important;
            background-color: transparent !important;
            font-size: 14px !important;
            line-height: 1.4 !important;
            font-weight: var(--FONT-WEIGHT-REGULAR) !important;
            color: #7a7a7a !important;
          }
          

          #app-embed div#form-container-ref label,
          fieldset legend,
          div#form-container-ref span {
            font-family: var(--GOTHAM-FONT) !important;
            font-size: 16px !important;
            line-height: 1.4 !important;
            font-weight: var(--FONT-WEIGHT-REGULAR) !important;
            color: #7a7a7a !important;
          }

          #app-embed div#form-container-ref label {
            left: 0 !important;
            top: 10px !important;
          }

          div#form-container-ref input {
            height: 100% !important;
            padding: 18px 0 12px 0 !important;
          }

          div#form-container-ref input[type='radio'] {
              accent-color: #000000 !important;
          }

          div#form-container-ref textarea {
            padding: 16px 0 !important;
          }

          #app-embed div#form-container-ref label#label-phone_number {
            translateY(var(--input-label-Y-transform)) scale(1) !important;
            top: 10px !important;
          }
            
          #app-embed div#form-container-ref textarea::after {
            border-top: 2px solid #7a7a7a;
            width: 12px;
            transform: rotate(-45deg);
            position: absolute;
            bottom: 8px;
            right: 1px;
            pointer-events: none;
            border-radius: 25%;
            content: "";
            display: block;
          }

          #app-embed div#form-container-ref textarea::before {
            content: "";
            display: block;
            border-top: 2px solid #7a7a7a;
            width: 5px;
            transform: rotate(-45deg);
            position: absolute;
            bottom: 5px;
            right: 1px;
            pointer-events: none;
            border-radius: 25%;
          }


          button[aria-controls="country-selector-dropdown"] {
            max-height: 100%;
          }

          ._formFieldContainer_1mxsl_5:has(textarea)::before {
            background-color: transparent !important;
          }

          button[type="submit"] {
              font: normal 700 16px var(--GOTHAM-FONT) !important; 
          }

          form {
              gap: 20px !important;
          }

          div[data-sizing="form-wrapper"] {
              padding: 0 var(--outer) !important;
          }

          section[data-sizing="form-wrapper"] {
              max-width: 680px !important;
          }

          section[data-testid="banner-success"],
          section[data-testid="banner-success"] h2{
              text-align: center !important;
              justify-content: center !important;
          }

          div[data-sizing="form-wrapper"] button[type="submit"] {
            --btn-text: #FFFFFF;
            --btn-bg: #000000;  
            --btn-top: 14px;
            -webkit-user-select: none;
            user-select: none;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            position: relative;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: auto;
            padding: var(--btn-top) var(--btn-left);
            border: 1px solid var(--btn-border);
            border-radius: var(--btn-radius);
            background-color: var(--btn-bg);
            font-family: var(--GOTHAM-FONT) !important;
            font-size: var(--BTN-FONT-SIZE) !important;
            line-height: var(--line-height-normal) !important;
            color: var(--btn-text);
            font-style: var(--BTN-FONT-STYLE);
            font-weight: 400 !important;
            letter-spacing: var(--BTN-LETTER-SPACING);
            text-decoration: none;
            text-align: center;
            vertical-align: middle;
            text-transform: var(--BTN-UPPERCASE);
            transition: 0.25s ease-out;
            transition-property: color, background, border;
            -webkit-backface-visibility: hidden;
                    backface-visibility: hidden;
            overflow-wrap: anywhere;
            --icons: var(--btn-text);
          }

          div.form-info-block {
            display: none;
          }



        `;
        shadow.appendChild(style);

        if (dataPositionForm == '') return;

        waitForElement('input[id="custom#visionary"]', shadow).then(inputEl => {
          const parent =inputEl.closest('._formFieldContainer_1mxsl_5'); 

          const infoDiv = document.createElement('div');
          infoDiv.classList.add('form-info-block')
          infoDiv.innerHTML = dataPositionForm.richtext_for_position_form;

          parent.parentNode.insertBefore(infoDiv, parent);
        });
      }
    });
  }